import React, { useState } from 'react';
import {
  Routes,
  Navigate,
  Route,
  useNavigate,
  useLocation,
} from 'react-router';
import request from 'superagent';
import { AdditionalView, ContactView, ErrorView, NameView } from './views';
import update from 'immutability-helper';
import ProgressDisplay from '@components/application/progressDisplay';
import PropTypes from 'prop-types';

const VehicleEnquiryContainer = ({
  authenticityToken,
  finance,
  postcode,
  recaptchaSiteKey,
  stockReference,
  vehicleUrl,
  quoteCode,
  quoteToken,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [enquiry, setEnquiry] = useState({
    customerDetails: {},
    dealbuilder: !!quoteCode,
    finance,
    interestedInFinance: false,
    postcode,
    quoteCode,
    quoteToken,
  });

  const [error, setError] = useState(false);
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);

  const generateRoute = (routeName) => {
    return quoteCode && quoteToken
      ? `${routeName}/${stockReference}/${quoteCode}/${quoteToken}`
      : `${routeName}/${stockReference}`;
  };

  const steps = [
    {
      name: 'Your Name',
      route: generateRoute('/new'),
    },
    {
      name: 'Your Contact Details',
      route: generateRoute('/contact-details'),
    },
    {
      name: 'Your Comments',
      route: generateRoute('/comments'),
    },
    {
      name: 'Error',
      route: generateRoute('/error'),
    },
  ];

  const stepIndex = steps.findIndex((step) => step.route === location.pathname);

  const nextView = () => {
    navigate(steps[stepIndex + 1].route);
  };

  const updateCustomerDetails = (data, callback) => {
    const newCustomerDetails = update(enquiry.customerDetails, {
      $merge: data,
    });

    setEnquiry({ ...enquiry, customerDetails: newCustomerDetails });

    if (callback) callback({ ...enquiry, customerDetails: newCustomerDetails });
  };

  const prepareEnquiry = (enquiry) => {
    return {
      ...enquiry.customerDetails,
      interested_in_finance: enquiry.interestedInFinance,
      dealbuilder: enquiry.dealbuilder,
      quote_code: enquiry.quoteCode,
      quote_token: enquiry.quoteToken,
    };
  };
  const sendEnquiry = (enquiry) => {
    setLoading(true);

    request
      .post(`/contact-us/vehicle-enquiry/create/${stockReference}`)
      .set('Accept', 'application/json')
      .send({
        authenticity_token: authenticityToken,
        reserve_now: false,
        enquiry: prepareEnquiry(enquiry),
        ...(enquiry.customerDetails['g-recaptcha-response'] && {
          'g-recaptcha-response':
            enquiry.customerDetails['g-recaptcha-response'],
        }),
      })
      .then((response) => {
        window.location.href = `/contact-us/thank-you/deal-builder?stock_reference=${stockReference}&enquiry=${response.body.id}`;
      })
      .catch((data) => {
        setError(true);
        setErrors(data.response.body.errors);
        setLoading(false);
      });
  };

  const stepName = steps[stepIndex]?.name;

  const exitEnquireJourney = () => {
    window.location.href = vehicleUrl;
  };

  return (
    <>
      <div className="ch-bg--white reserve-now__header">
        <button
          className="ac-exit-button ch-ba--0 ch-float--right ch-color--ac-black ch-bg--grey-2 ch-rounded--sm ch-fs--2 ch-fw--500 ch-ma--4"
          onClick={exitEnquireJourney}
          type="button"
        >
          Exit
        </button>
      </div>
      <div className="ch-bg--white">
        {!enquiry.dealbuilder && !error && (
          <ProgressDisplay
            currentStep={stepIndex + 1}
            stepName={stepName}
            stepped
            totalSteps={steps.length - 1}
          />
        )}
      </div>
      <div className="db-body">
        <Routes>
          {error && (
            <>
              <Navigate replace to={generateRoute('/error')} />
              <Route
                element={
                  <ErrorView
                    errors={errors}
                    firstView={steps[0].route}
                    setError={setError}
                  />
                }
                path={generateRoute('/error')}
              />
            </>
          )}
          <Route
            element={
              <NameView
                firstName={enquiry.customerDetails.first_name}
                lastName={enquiry.customerDetails.last_name}
                nextView={nextView}
                updateCustomerDetails={updateCustomerDetails}
              />
            }
            path={generateRoute('/new')}
          />
          <Route
            element={
              <ContactView
                contactEmail={enquiry.customerDetails.contact_email}
                contactNumber={enquiry.customerDetails.contact_number}
                nextView={nextView}
                postcode={enquiry.customerDetails.postcode}
                updateCustomerDetails={updateCustomerDetails}
              />
            }
            path={generateRoute('/contact-details')}
          />
          <Route
            element={
              <AdditionalView
                dealbuilder={enquiry.dealbuilder}
                loading={loading}
                recaptchaSiteKey={recaptchaSiteKey}
                sendEnquiry={sendEnquiry}
                updateCustomerDetails={updateCustomerDetails}
              />
            }
            path={generateRoute('/comments')}
          />
        </Routes>
      </div>
    </>
  );
};

export default VehicleEnquiryContainer;

VehicleEnquiryContainer.propTypes = {
  authenticityToken: PropTypes.string,
  finance: PropTypes.object,
  postcode: PropTypes.string,
  quoteCode: PropTypes.string,
  quoteToken: PropTypes.string,
  recaptchaSiteKey: PropTypes.string,
  stockReference: PropTypes.string,
  vehicleUrl: PropTypes.string,
};
